import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import './index.css';

import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import MyHolidays from './pages/MyHolidays';
import RequestHoliday from './pages/RequestHoliday';
import DirectorDashboard from './pages/DirectorDashboard';
import ManageRequests from './pages/ManageRequests';
import TeamCalendar from './pages/TeamCalendar';
import AdminUsers from './pages/AdminUsers';
import ChangePassword from './pages/ChangePassword';
import Tasks from './pages/Tasks';
import ClientLogin from './pages/client/ClientLogin';
import ClientPortal from './pages/client/ClientPortal';
import Jobs from './pages/Jobs';
import JobDetail from './pages/JobDetail';
import FloorPlans from './pages/FloorPlans';
import FloorPlanEditor from './pages/FloorPlanEditor';

const PrivateRoute = ({ children, roles }) => {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
};

const AppRoutes = () => {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/client/login" element={<ClientLogin />} />
      <Route path="/client" element={localStorage.getItem('cw_client_token') ? <ClientPortal /> : <Navigate to="/client/login" replace />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
        <Route index element={<Dashboard />} />
        <Route path="my-holidays" element={<MyHolidays />} />
        <Route path="request" element={<RequestHoliday />} />
        <Route path="change-password" element={<ChangePassword />} />
        <Route path="tasks" element={<PrivateRoute roles={['director','admin']}><Tasks /></PrivateRoute>} />
        <Route path="jobs" element={<PrivateRoute roles={['director','admin']}><Jobs /></PrivateRoute>} />
        <Route path="jobs/:id" element={<PrivateRoute roles={['director','admin']}><JobDetail /></PrivateRoute>} />
        <Route path="floor-plans" element={<PrivateRoute roles={['admin']}><FloorPlans /></PrivateRoute>} />
        <Route path="floor-plans/:id" element={<PrivateRoute roles={['admin']}><FloorPlanEditor /></PrivateRoute>} />
        <Route path="director" element={<PrivateRoute roles={['director','admin']}><DirectorDashboard /></PrivateRoute>} />
        <Route path="manage-requests" element={<PrivateRoute roles={['director','admin']}><ManageRequests /></PrivateRoute>} />
        <Route path="team-calendar" element={<PrivateRoute roles={['director','admin']}><TeamCalendar /></PrivateRoute>} />
        <Route path="admin/users" element={<PrivateRoute roles={['admin']}><AdminUsers /></PrivateRoute>} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

const App = () => (
  <BrowserRouter>
    <AuthProvider>
      <AppRoutes />
    </AuthProvider>
  </BrowserRouter>
);

export default App;
